import { createSelector } from 'reselect';

const purchaseTypePointer = state => state.dictionary.purchaseType;

export default createSelector([purchaseTypePointer], purchaseType =>
  purchaseType.map(e => {
    let proTypeId = null;
    switch (e.id) {
      case 1:
        proTypeId = 3;
        break;
      case 5:
        proTypeId = 2;
        break;
      case 3:
      case 4:
      case 6:
        proTypeId = 1;
        break;
      default:
        proTypeId = e.id;
        break;
    }
    return { ...e, proTypeId };
  }),
);
